module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "app-main app-main--fee-details view"
  }, [_c('pane-header', {
    attrs: {
      "tools": _vm.tools,
      "hasBackButton": true,
      "title": "Fee/fine Details"
    }
  }), _vm._v(" "), _c('ui-scrollable-container', [(false) ? _c('pre', [_vm._v("            " + _vm._s(JSON.stringify(_vm.currentView, null, 4)) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('ui-padding', [_c('div', {
    staticClass: "fee-details__buttons"
  }, [_c('ui-button', {
    attrs: {
      "title": "Pay"
    }
  }), _vm._v(" "), _c('ui-button', {
    attrs: {
      "title": "Waive"
    }
  }), _vm._v(" "), _c('ui-button', {
    attrs: {
      "title": "Refund"
    }
  }), _vm._v(" "), _c('ui-button', {
    attrs: {
      "title": "Transfer"
    }
  }), _vm._v(" "), _c('ui-button', {
    attrs: {
      "title": "Error"
    }
  })], 1)]), _vm._v(" "), _c('ui-padding', [_c('ui-details', {
    style: ({
      padding: 0
    }),
    attrs: {
      "size": "w250 no-padding",
      "list": [{
          label: 'Patron',
          value: ((_vm.user.lastname) + ", " + (_vm.user.firstname) + " (" + (_vm.user.patron_group) + ")"),
        },
        'break',
        {
          label: 'Fee/fine type',
          value: _vm.fee.fee_type,
        },
        {
          label: 'Fee/fine owner',
          value: _vm.fee.fee_owner,
        },
        {
          label: 'Charge date',
          value: _vm.fee.charge_date,
        },
        {
          label: 'Original fee/fine',
          value: _vm.fee.amount,
        },
        {
          label: 'Outstanding amount',
          value: _vm.fee.remaining,
        },
        'break',
        {
          label: 'Item type',
          value: _vm.fee.item_type,
        },
        {
          label: 'Title',
          value: _vm.fee.item_name,
        },
        {
          label: 'Barcode',
          value: _vm.fee.barcode,
        },
        {
          label: 'Call number',
          value: _vm.fee.call_number,
        },
        {
          label: 'Location',
          value: _vm.fee.fee_owner,
        } ]
    }
  }), _vm._v(" "), _c('ui-link', {
    on: {
      "click": _vm.viewLoanDetails
    }
  }, [_vm._v("View loan details")])], 1), _vm._v(" "), _c('ui-padding', [_c('ui-data-list', {
    staticClass: "col-min-120",
    attrs: {
      "preset": "fee_action",
      "type": "results",
      "tools": _vm.tools,
      "maxItems": 4,
      "minItems": 2,
      "cache": true
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00937fc2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/FeeDetailsView.vue
// module id = 420
// module chunks = 1